import React from "react";
import { Box, Typography, Container } from "@mui/material";
import Navbar from "../components/Navbar";
import FlyCodeBanner from "../components/home/FlyCodeBanner";
import FooterSection from "../components/home/FooterSection";

const About = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#ffffff",
        color: "#000000",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <FlyCodeBanner />
      <Navbar />

      <Container
        maxWidth="md"
        sx={{
          pt: 20,
          pb: 8,
          px: { xs: 3, md: 4 },
        }}
      >
        {/* Main Content - Cluely Style */}
        <Box sx={{ textAlign: "left", maxWidth: "800px", mx: "auto" }}>
          {/* Main Headline */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              fontWeight: 700,
              mb: 6,
              color: "#000000",
              lineHeight: 1.1,
              letterSpacing: "-0.02em",
            }}
          >
            We want to democratize education.
          </Typography>

          {/* Subheading */}
          <Typography
            sx={{
              fontSize: "1.25rem",
              fontWeight: 400,
              mb: 8,
              color: "#000000",
              lineHeight: 1.4,
            }}
          >
            Yep, you heard that right.
          </Typography>

          {/* First Paragraph */}
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 400,
              mb: 4,
              color: "#000000",
              lineHeight: 1.6,
            }}
          >
            Textbooks. Study materials. Academic resources. If there's a way to
            make learning more accessible — we'll take it.
          </Typography>

          {/* Second Paragraph */}
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 400,
              mb: 4,
              color: "#000000",
              lineHeight: 1.6,
            }}
          >
            We built EduTools so students never have to struggle alone again. It
            connects communities. Shares resources. Provides answers in real
            time. While others pay full price — you're already saving.
          </Typography>

          {/* Third Paragraph */}
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 400,
              mb: 4,
              color: "#000000",
              lineHeight: 1.6,
            }}
          >
            And yes, the world will call it disruptive.
          </Typography>

          {/* List of Examples */}
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 400,
              mb: 4,
              color: "#000000",
              lineHeight: 1.6,
            }}
          >
            But so was the library. So was the internet. So was online learning.
          </Typography>

          {/* Fourth Paragraph */}
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 400,
              mb: 4,
              color: "#000000",
              lineHeight: 1.6,
            }}
          >
            Every time technology makes education more accessible, the world
            panics. Then it adapts. Then it forgets. And suddenly, it's normal.
          </Typography>

          {/* Quote Block */}
          <Box
            sx={{
              borderLeft: "3px solid #000000",
              pl: 3,
              my: 6,
            }}
          >
            <Typography
              sx={{
                fontSize: "1.125rem",
                fontWeight: 400,
                mb: 2,
                color: "#000000",
                lineHeight: 1.6,
                fontStyle: "italic",
              }}
            >
              But this is different.
            </Typography>
          </Box>

          {/* Fifth Paragraph */}
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 400,
              mb: 4,
              color: "#000000",
              lineHeight: 1.6,
            }}
          >
            Technology isn't just another tool — It will redefine how education
            works.
          </Typography>

          {/* Sixth Paragraph */}
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 400,
              mb: 4,
              color: "#000000",
              lineHeight: 1.6,
            }}
          >
            Why pay thousands for textbooks, struggle with access, research{" "}
            <em>anything</em> — when a platform can connect you in seconds?
          </Typography>

          {/* Seventh Paragraph */}
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 400,
              mb: 4,
              color: "#000000",
              lineHeight: 1.6,
            }}
          >
            The best student, the best researcher, the best collaborator — is
            now the one who knows how to leverage the right resources.
          </Typography>

          {/* Eighth Paragraph */}
          <Typography
            sx={{
              fontSize: "1.125rem",
              fontWeight: 400,
              mb: 4,
              color: "#000000",
              lineHeight: 1.6,
            }}
          >
            The future won't reward isolation. It'll reward community.
          </Typography>

          {/* Final Quote Block */}
          <Box
            sx={{
              borderLeft: "3px solid #000000",
              pl: 3,
              my: 6,
            }}
          >
            <Typography
              sx={{
                fontSize: "1.125rem",
                fontWeight: 400,
                mb: 2,
                color: "#000000",
                lineHeight: 1.6,
                fontStyle: "italic",
              }}
            >
              So, start sharing. Because when everyone does, everyone wins.
            </Typography>
          </Box>
        </Box>
      </Container>

      <div style={{ backgroundColor: "#0f0f0f" }}>
        <FooterSection />
      </div>
    </Box>
  );
};

export default About;
